
import { Component, Vue } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import CompanyTable from '../components/company_settle_table.vue'

@Component({
    name: 'enterprise-settle',
    components: {
        CompanyTable
    }
})
export default class extends Vue {
    private companyList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private isLoading = false
    private loadingText = ''
    private status = -1

    private statusOptions = [
        { label: '所有申请', value: -1 },
        { label: '审核中', value: 0 },
        { label: '通过', value: 1 },
        { label: '不通过', value: 2 }
    ]

    private async mounted() {
        this.showLoading()
        await Promise.all([
            this.getCompanyList()
        ])
        this.hideLoading()
    }

    /** 获取机构列表 */ 
    private async getCompanyList() {
        const status = this.status === -1 ? undefined : this.status
        const params = {
            status: status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await EnterpriseService.getCompanySettleList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.companyList = result.data.list
        }
    }   

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getCompanyList()
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
